export interface RequestFormModalSchema {
  isOpen: boolean;
  title?: Nullable<string>;
  description?: Nullable<string>;
  mode?: Nullable<RequestModalMode>;
  square?: Nullable<number>;
  sizeCodeId?: Nullable<string>;
  boxName?: Nullable<string>;
}

export interface RequestFormModalPayload {
  title?: Nullable<string>;
  description?: Nullable<string>;
  mode?: Nullable<RequestModalMode>;
  square?: Nullable<number>;
  sizeCodeId?: Nullable<string>;
  boxName?: Nullable<string>;
}

export enum RequestModalMode {
  CONTACT_US = 'contact us',
  REQUEST_BOX = 'request a box',
  REQUEST_OFFER = 'request an offer',
  BOOK_TOUR = 'book_tour',
}
